(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('shop-look-modal');
  const modalProductsContainer = document.getElementById('shop-look-products');
  const closeModal = document.getElementById('close-shop-look');

  document.querySelectorAll('.shop-the-look-overlay').forEach(button => {
    button.addEventListener('click', function() {
      const blockId = this.dataset.look;
      const productsData = document.getElementById(`products-${blockId}`);
      const products = productsData ? JSON.parse(productsData.textContent) : [];

      modalProductsContainer.innerHTML = '';

      if (products.length > 0) {
        products.forEach(product => {
          modalProductsContainer.innerHTML += `
            <div class="shop-look-product">
              <img src="${product.image}" alt="${product.title}">
              <h4>${product.title}</h4>
              <div class="price">${product.price}</div>
              <a href="${product.url}">View Product</a>
            </div>
          `;
        });
      } else {
        modalProductsContainer.innerHTML = `<p>No products assigned to this look yet.</p>`;
      }

      modal.classList.add('active');
    });
  });

  closeModal.addEventListener('click', () => modal.classList.remove('active'));
  window.addEventListener('click', e => {
    if (e.target === modal) modal.classList.remove('active');
  });
});

  } catch(e) { console.error(e); }
})();
})();
